import { useMemo } from 'react'
import { Box, Link } from '@mui/material'
import { observer } from 'mobx-react-lite'

import { AcImage, AcTitle, AcTypography } from '@components'
import { ISingleContentBlockGallery } from '@typings'

interface IAcGallery extends ISingleContentBlockGallery {
  home?: boolean
}

export const AcGallery = observer(
  ({ title, description, items }: IAcGallery) => {
    const renderRows = useMemo(() => {
      return items.map((row, index) => (
        <Box
          sx={{
            background:
              'color-mix(in srgb, var(--ac-palette-grey-100) 24%, transparent)',
            border: '1px solid var(--ac-palette-grey-200)',
            borderRadius: '4px',
            textAlign: 'center',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}>
          <Box
            sx={{
              background: '#c0eafc',
              borderLeft: '3px solid var(--ac-palette-primary-main)',
              color: 'var(--ac-palette-primary-main)',
              paddingBottom: '4rem',
              boxShadow:
                '1.865px 1.865px 3.731px 0 rgba(0, 0, 0, 0.05), ' +
                '5.596px 5.596px 9.327px 0 rgba(0, 0, 0, 0.11), ' +
                '11.193px 11.193px 13.058px 0 rgba(0, 0, 0, 0.12)',
            }}>
            <AcTypography
              mt={6}
              mb={4}
              size="s"
              weight="bold">
              {row.title}
            </AcTypography>
            {row.image && <AcImage {...row.image} />}
          </Box>

          {row.url && (
            <Link
              href={row.url}
              mt={2}>
              PDF bekijken &gt;
            </Link>
          )}
        </Box>
      ))
    }, [items])

    const renderText = useMemo(() => {
      return (
        <Box>
          <AcTitle
            level={2}
            color="primary">
            {title}
          </AcTitle>
          <AcTypography>{description}</AcTypography>
        </Box>
      )
    }, [description, title])

    const renderContent = useMemo(() => {
      return (
        <>
          {renderText}
          <Box
            sx={{
              display: 'grid',
              gap: '1.5rem',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr 1fr' },
            }}>
            {renderRows}
          </Box>
        </>
      )
    }, [])

    return renderContent
  },
)
